const ADMIN_ROLE_ID = 1;
const OPERATIONAL_ROLE_ID = 4;
const ADMIN_ROLE_STORAGE_KEY = "adminRoleId";

const getCurrentRoleId = () => {
    const roleId = localStorage.getItem(ADMIN_ROLE_STORAGE_KEY);

    if (!roleId) return null;

    const parsedRoleId = Number(roleId);

    return Number.isNaN(parsedRoleId) ? null : parsedRoleId;
};

const hasRoleAccess = (allowedRoles = []) => {
    if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
        return false;
    }

    const currentRoleId = getCurrentRoleId();

    if (currentRoleId === null) return false;

    return allowedRoles.includes(currentRoleId);
};

const isOperational = () => getCurrentRoleId() === OPERATIONAL_ROLE_ID;

const canEditProducts = () => getCurrentRoleId() === ADMIN_ROLE_ID;

export {
    ADMIN_ROLE_ID,
    OPERATIONAL_ROLE_ID,
    ADMIN_ROLE_STORAGE_KEY,
    getCurrentRoleId,
    hasRoleAccess,
    isOperational,
    canEditProducts,
};
